import React, { useState } from 'react';
import useSaveSelectionConfiguration from '../useSaveSelectionConfiguration';
import { selectionPayload } from '../registrationConfiguration';
import SelectionForm from './SelectionForm';
import PortalFormModal from './PortalFormModal';
import { richTextIsEmpty } from './PortalRichTextField';

export default function RegistrationConfigurationModal({ selection, onClose, onSaved }) {
  const save = useSaveSelectionConfiguration(selection);
  const [error, setError] = useState(null);
  return (
    <PortalFormModal
      title="Informações e período de inscrição"
      description={selection.title}
      onClose={onClose}
      busy={save.isLoading}
      allowed={save.allowed}
      error={error || save.error}
      onSubmit={(event) => {
        try {
          const values = selectionPayload(event.currentTarget, selection);
          if (richTextIsEmpty(values.terms))
            throw new Error('Informe as condições para inscrição.');
          if (values.terms.length > 30000)
            throw new Error(
              'As condições devem ter no máximo 30.000 caracteres, incluindo a formatação.'
            );
          setError(null);
          save.mutate(values, {
            onSuccess: () => {
              onSaved({});
              onClose();
            },
          });
        } catch (failure) {
          setError(failure);
        }
      }}
    >
      <SelectionForm selection={selection} disabled={save.isLoading || !save.allowed} />
    </PortalFormModal>
  );
}
